<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card>
      <v-card-title>
            <span class="title">Order History</span>
            <v-spacer></v-spacer>
            <v-btn class="blue-grey" fab small dark @click.native.stop="rightDrawer = !rightDrawer">
              <v-icon>search</v-icon>
            </v-btn>
            <v-btn class="brown lighten-1" fab small dark @click.native="reloadData()">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-card-title>
          <div id='tablecontrols'>
    <input type="checkbox" id="idheader" v-bind:value='{ "text": "#", "value": "id", "left": true }' v-model="headers">
    <label for="idheader">Order #</label>
    <input type="checkbox" id="imeiheader" v-bind:value='{ "text": "IMEI", "value": "imei" }' v-model="headers" checked>
    <label for="imeiheader">IMEI</label>
    <input type="checkbox" id="serviceheader" v-bind:value='{ "text": "Service", "value": "Service" }' v-model="headers">
    <label for="serviceheader">Service</label>
      <input type="checkbox" id="replyheader" v-bind:value='{ "text": "Reply", "value": "reply" }' v-model="headers">
      <label for="replyheader">Reply</label>
      <input type="checkbox" id="statusheader" v-bind:value='{ "text": "Status", "value": "status" }' v-model="headers">
      <label for="statusheader">Status</label>
      <input type="checkbox" id="listidheader" v-bind:value='{ "text": "List #", "value": "listid" }' v-model="headers">
      <label for="listidheader">List #</label>
      <input type="checkbox" id="timeheader" v-bind:value='{ "text": "Ordered On", "value": "time" }' v-model="headers">
      <label for="timeheader">Time</label>
      <input type="checkbox" id="replytimeheader" v-bind:value='{ "text": "Replied On", "value": "replytime" }' v-model="headers">
      <label for="replytimeheader">Reply Time</label>
      <input type="checkbox" id="priceheader" v-bind:value='{ "text": "Price", "value": "price" }' v-model="headers">
      <label for="priceheader">Price</label>
      <input type="checkbox" id="ipheader" v-bind:value='{ "text": "IP", "value": "ip" }' v-model="headers">
      <label for="ipheader">IP</label>
    <br>

  </div>
        <Table v-if="loading===false" :headers="headers" :items="items"  :pagination="pagination"></Table>
      </v-card>
    </v-flex>
    <search-panel :rightDrawer="rightDrawer" @cancelSearch="cancelSearch" @searchData="searchOrders">
        <v-layout row>
          <v-flex xs11 offset-xs1>
            <v-text-field name="id" label="List" light v-model="searchVm.equals.listid"></v-text-field>
            <v-select name="status" :items="statuss" label="Status" light v-model="searchVm.equals.status"></v-select>
            <br>
            Start Date: <datepicker :format="customFormatter" v-model="searchVm.equals.start"></datepicker>
            End Date: <datepicker :format="customFormatter" v-model="searchVm.equals.end"></datepicker>
            <br>
            <v-textarea label="IMEIs" v-model="searchVm.equals.imeilist"></v-textarea>
            </v-flex>
        </v-layout>
      </search-panel>

      <v-snackbar v-if="loading===false" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
/* globals Store */
import Table from "@/components/Table.vue";
import SearchPanel from "@/components/SearchPanel.vue";
import { mapState } from "vuex";
import { debounce } from "lodash";
import api from "@/utils/backend-api";
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {
  components: {
    Table,
    SearchPanel,
    Datepicker
  },
  data () {
    return {
      statuss: ['New', 'In Process', 'Rejected', 'Replied'],
      dialog: false,
      dialogTitle: "Order Delete Dialog",
      dialogText: "Do you want to delete this order?",
      rightDrawer: false,
      right: true,
      search: '',
      techs: [],
      headers: [
      { "text": "#", "value": "id", "left": true },
      { "text": "IMEI", "value": "imei" },
      { "text": "Reply", "value": "reply" },
      { "text": "Status", "value": "status" }
      ],
      searchVm: {
        contains: {
          jobid: '',
        },
        equals: {
          listid: '',
          imeilist: "",
          start: new Date(),
          end: new Date(),
          status: '',
        },
      },
      searchimeis: "",
      orderId: "",
      query: "",
      snackbarStatus: false,
      timeout: 2000,
      color: "",
      quickSearchFilter: "",
    }
  },
  methods: {
  customFormatter(date) {
     return moment(date).format('YYYY-MM-DD');
   },
    searchOrders () {
      this.rightDrawer = !this.rightDrawer;
      this.searchVm.equals.start = this.customFormatter(this.searchVm.equals.start);
      this.searchVm.equals.end = this.customFormatter(this.searchVm.equals.end);
      this.searchimeis = this.searchVm.equals.imeilist;
      this.searchVm.equals.imeilist = "";
      this.appUtil.buildSearchFilters(this.searchVm);
      this.query = this.appUtil.buildJsonServerQuery(this.searchVm);

      var searcher = {"searchQuery": this.query, "postData": this.searchimeis};

      Store.dispatch("orders/searchOrders", searcher, this.pagination);
    },
    reloadData () {
      this.query = "";
      Store.dispatch("orders/getAllOrders");
    },
    cancelSearch () {
      this.rightDrawer = false;
    },
    closeSnackbar () {
      Store.commit("orders/setSnackbar", { snackbar: false });
      Store.commit("orders/setNotice", { notice: "" });
    },
  },
  computed: {
    ...mapState("orders", {
      items: "items",
      pagination: "pagination",
      loading: "loading",
      mode: "mode",
      snackbar: "snackbar",
      notice: "notice"
    }),
  },
  created () {
    Store.dispatch("orders/getAllOrders");
  },
  mounted () {
    this.$nextTick(() => {
      // console.log(this.headers);
    })
  }
}
</script>



// WEBPACK FOOTER //
// OrderHistory.vue?e24ac632